import { render } from "./VTableTd.vue?vue&type=template&id=0cd09a6d"
import script from "./VTableTd.vue?vue&type=script&lang=js"
export * from "./VTableTd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__